import { Route, Switch } from 'react-router-dom';
import { CareerHubRedirectPage } from 'src/ui/features/careerhub/pages/CareerHubRedirectPage';
import { careerhubPaths } from './paths/careerhub.paths';

export const CareerHubRouter = () => (
    <Switch>
        <Route path={careerhubPaths.redirect} component={CareerHubRedirectPage} />
    </Switch>
);
